import { Switch as NovaSwitch, SwitchProps as NovaSwitchProps } from '@fme-nova/components'
import { default as MuiSwitch, SwitchProps as MuiSwitchProps } from '@mui/material/Switch'

import { createComponentWrapperWithRef } from '../../theme'

type SwitchProps = Omit<MuiSwitchProps | NovaSwitchProps, 'ref'>

export const Switch = createComponentWrapperWithRef<SwitchProps>(
  {
    mui: MuiSwitch,
    nova: NovaSwitch,
  },
  'Switch',
)
